import { User } from '@elio/emanager-front/auth/model';
import { ElioError } from '@elio/shared/models';
import { createAction, props } from '@ngrx/store';

const loadUserSuccess = createAction('[User Effect] Load user SUCCESS', props<{ user: User }>());
const loadUserFailure = createAction('[User Effect] Load user FAILURE', props<{ error: ElioError }>());
const updateUserSuccess = createAction('[User Effect] update user SUCCESS', props<{ user: User }>());
const userIsAlreadyLoaded = createAction('[User Effect] User is already loaded');
const loadUserFailureNoRedirection = createAction(
  '[User Effect] Load user FAILURE with no login redirection',
  props<{ error: ElioError }>()
);
const userHasUnauthorizedOffers = createAction(
  '[User Effect] User has unauthorized offers',
  props<{ user: User; unauthorizedOffers: number[] }>()
);
const userIsNavigatingOnUnauthorizedOffer = createAction(
  '[User Effect] User is navigating on an unauthorized offer',
  props<{ user: User; unauthorizedOffers: number[] }>()
);
const userHasNoOffersNorHqLeft = createAction(
  '[User Effect] user does not have any authorized offers or headquarters '
);
const userIsNavigatingOnUnauthorizedHeadquarter = createAction(
  '[User Effect] User is navigating on an unauthorized headquarter',
  props<{ user: User }>()
);

export const UserEffectActions = {
  loadUserSuccess,
  loadUserFailure,
  updateUserSuccess,
  userIsAlreadyLoaded,
  loadUserFailureNoRedirection,
  userHasUnauthorizedOffers,
  userHasNoOffersNorHqLeft,
  userIsNavigatingOnUnauthorizedHeadquarter,
  userIsNavigatingOnUnauthorizedOffer,
};
